// Library methods
import { useTranslation } from "react-i18next";
import useMediaQuery from "@mui/material/useMediaQuery";

// Components
import Box from "@mui/material/Box";
import DefaultModal from "src/components/shared/modals/DefaultModal/DefaultModal";

// Styles
import { useTheme } from "@mui/material/styles";

type ExpandDevicesModalType = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

const ExpandDevicesModal = ({
  open,
  onClose,
  children,
}: ExpandDevicesModalType) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <DefaultModal
      isOpen={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      title={t("Devices")}
    >
      <Box padding="16px">{children}</Box>
    </DefaultModal>
  );
};

export default ExpandDevicesModal;
